import { Controller, useFormContext } from "react-hook-form";
import { FormHelperText, Box, FormLabel, Stack, Chip } from "@mui/material";
const MultiSelectChip = ({ field }) => {
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  const handleChipClick = (value) => {
    const fieldValue = getValues(field.id) || [];
    const newValue = fieldValue.includes(value)
      ? fieldValue.filter((v) => v !== value)
      : [...fieldValue, value];
    setValue(field.id, newValue);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue={[]}
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { value = [] } }) => (
          <Box>
            <FormLabel
              required={Boolean(field.required)}
              sx={{ fontWeight: 500, color: "text.primary" }}
            >
              {field.label}
            </FormLabel>
            <Stack
              direction="row"
              sx={{
                mt: 1.5,
              }}
              spacing={1}
              rowGap={1}
              flexWrap="wrap"
            >
              {field.options?.map((option) => (
                <Chip
                  key={option.label}
                  label={option.label}
                  onClick={() => handleChipClick(option.label)}
                  sx={{
                    minWidth: 50,
                  }}
                  color={value.includes(option.label) ? "primary" : "default"}
                />
              ))}
            </Stack>
            {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
          </Box>
        )}
      />
    </Box>
  );
};

export default MultiSelectChip;
